<mat-card>
    <mat-card-header>
        <mat-card-title class="text-center">
            <img [alt]="companyName + ' Logo'" [src]="companyImg" class="w-25 mx-auto">
        </mat-card-title>
        <mat-card-subtitle>
            <h3>Password Reset</h3>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="passwordForm">
            <div class="flex-col">
                <mat-form-field appearance="outline" class="w-100" color="primary">
                    <mat-label>New Password</mat-label>
                    <input #password [type]="showpassword ? 'text' : 'password'" formControlName="password" matInput
                           maxlength="32"
                           minlength="8" required>
                    <button (click)="showpassword = !showpassword"
                            [matTooltip]="showpassword ? 'Show password' : 'Hide password'"
                            class="h-fit-content p0" mat-icon-button
                            matSuffix
                            type="button">
                        <mat-icon *ngIf="!showpassword" color="accent">remove_red_eye
                        </mat-icon>
                        <mat-icon *ngIf="showpassword" color="accent">highlight_off</mat-icon>
                    </button>
                    <mat-error (click)="password.focus()"
                               *ngIf="passwordForm.controls['password'].hasError('required')">
                        This field is required
                    </mat-error>
                    <mat-error (click)="password.focus()"
                               *ngIf="passwordForm.controls['password'].hasError('minlength')"
                               [style.color]="community?.password_minimum_character_alert_colour_hex">
                        Password must be at least 8 characters long
                    </mat-error>
                    <mat-error (click)="password.focus()"
                               *ngIf="passwordForm.controls['password'].hasError('maxlength')">
                        Password must be at less than 32 characters long
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100" color="primary">
                    <mat-label>Confirm New Password</mat-label>
                    <input #confirmPassword [type]="showConfirmPassword ? 'text' : 'password'"
                           formControlName="confirmPassword"
                           matInput required>
                    <button (click)="showConfirmPassword = !showConfirmPassword"
                            [matTooltip]="showConfirmPassword ? 'Show password' : 'Hide password'"
                            class="h-fit-content p0" mat-icon-button
                            matSuffix
                            type="button">
                        <mat-icon *ngIf="!showConfirmPassword" color="accent">remove_red_eye
                        </mat-icon>
                        <mat-icon *ngIf="showConfirmPassword" color="accent">highlight_off</mat-icon>
                    </button>
                    <mat-error (click)="confirmPassword.focus()"
                               *ngIf="passwordForm.controls['confirmPassword'].hasError('required')">
                        This field is required
                    </mat-error>
                    <mat-hint (click)="confirmPassword.focus()"
                              *ngIf="confirmPassword.value && password.value && password.value != confirmPassword.value"
                              class="errorMsg">
                        Fields must match
                    </mat-hint>
                </mat-form-field>
            </div>
        </form>
    </mat-card-content>
    <mat-card-actions class="text-center flex-space-around">
        <button (click)="resetPassword()"
                [disabled]="passwordForm.invalid || loading || password.value != confirmPassword.value"
                class="mx-auto my-10"
                color="primary" mat-flat-button type="submit">
            Update Password
            <mat-icon *ngIf="loading">
                <mat-spinner color="primary" width="40px"></mat-spinner>
            </mat-icon>
        </button>
    </mat-card-actions>
</mat-card>
